import { getDB } from './schema';
import { clearCredentialBackup } from './credentialBackup';

// Destructive maintenance actions exposed through the in-player settings panel,
// so an on-site installer can recover a screen without touching browser internals.

// Wipe downloaded playlist + media and reset the sync sequence, forcing a fresh
// content download on next boot. Keeps the device paired (token/uuid).
export async function clearContent(): Promise<void> {
  const db = await getDB();
  const tx = db.transaction(['content', 'media'], 'readwrite');
  await Promise.all([tx.objectStore('content').clear(), tx.objectStore('media').clear()]);
  await tx.done;
  await db.put('kv', 0, 'sequence');
}

// Full reset / logout: clear all content, media, queued logs and device
// identity. The next boot returns to the pairing screen.
export async function resetDevice(): Promise<void> {
  const db = await getDB();
  const tx = db.transaction(['content', 'media', 'logs', 'kv'], 'readwrite');
  await Promise.all([
    tx.objectStore('content').clear(),
    tx.objectStore('media').clear(),
    tx.objectStore('logs').clear(),
    tx.objectStore('kv').clear(),
  ]);
  await tx.done;
  // Also drop the localStorage credential backup, otherwise the next boot would
  // "recover" the just-unpaired device.
  clearCredentialBackup();
}
